import axios from 'axios';
import { Giveaway, GiveawayPrizeLine } from './types';

export interface CreateGiveawayPayload {
    title: string;
    description?: string | null;
    expires_at: string;
    prizes: Array<Pick<GiveawayPrizeLine, 'type' | 'plan' | 'winners_count'>>;
}

export const giveaways = {
    list() {
        return axios.get<{ giveaways: Giveaway[] }>('giveaways');
    },
    enter(id: number) {
        return axios.post<{ giveaway: Giveaway }>(`giveaways/${id}/enter`);
    },
    manage() {
        return axios.get<{ giveaways: Giveaway[] }>('giveaways/manage');
    },
    create(payload: CreateGiveawayPayload) {
        return axios.post<{ giveaway: Giveaway }>('giveaways', payload);
    },
    draw(id: number) {
        return axios.post<{ message: string; giveaway: Giveaway }>(`giveaways/${id}/draw`);
    },
    cancel(id: number) {
        return axios.post<{ giveaway: Giveaway }>(`giveaways/${id}/cancel`);
    },
};
